import './Features.css'
import attendanceRecordIcon from '../../assets/svg/attendanceRecord.svg'
import security from '../../assets/svg/security.svg'
import fiendly from '../../assets/svg/fiendly.svg'

function Features() {
    return (
        <div className='Features'>
            <div className='theme-heading-text'>Powerful Features Tailored for Your Business.</div>
            <div className='Features_card_container'>
                <div className='Features_card'>
                    <div className='icon-container'><div className='icon'><img src={attendanceRecordIcon} alt="attendanceRecordIcon" /></div></div>
                    <div className='d-flex flex-column gap-16'>
                        <div className='theme-heading-text-24'>Accurate Attendance Records</div>
                        <p className='theme-text-small-16'>Get precise data on employee attendance, aiding in reliable payroll processing and workforce management.</p>
                    </div>
                </div>
                <div className='Features_card'>
                    <div className='icon-container'><div className='icon'><img src={security} alt="security" /></div></div>
                    <div className='d-flex flex-column gap-16'>
                        <div className='theme-heading-text-24'>Enhanced Security</div>
                        <p className='theme-text-small-16'>Geofencing helps ensure that only employees physically present at the correct location can clock in, reducing the risk of time fraud.</p>
                    </div>
                </div>
                <div className='Features_card'>
                    <div className='icon-container'><div className='icon'><img src={fiendly} alt="fiendly" /></div></div>
                    <div className='d-flex flex-column gap-16'>
                        <div className='theme-heading-text-24'>User-Friendly Experience</div>
                        <p className='theme-text-small-16'>Employees can clock in effortlessly using their mobile devices, streamlining the attendance process without compromising security.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features
